var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.2717H13.9349V6.26145C13.9349 5.5065 14.4353 5.3305 14.7877 5.3305C15.1393 5.3305 16.9507 5.3305 16.9507 5.3305V2.01163L13.9718 2C10.665 2 9.91242 4.47532 9.91242 6.05938V8.2717H8V11.6916H9.91242C9.91242 16.0805 9.91242 21.3688 9.91242 21.3688H13.9349C13.9349 21.3688 13.9349 16.0284 13.9349 11.6916H16.6492L17 8.2717Z",
    fill: "#F0F1FA"
  })));
};
export default SvgSocialFacebook;